class Header extends HTMLElement {
  constructor() {
    super();
    this.settings = JSON.parse(this.querySelector(':scope > [type="application/json"]').innerText);
    this.onCloseMenuHandler = this.closeMenu.bind(this);
    this.setVariables();
    this.setEvents();
  }

  setVariables() {
    this.root = document.documentElement;
    this.scrollPos = window.pageYOffset || this.root.scrollTop;
    this.header = this.parentElement;
    this.selectors = {
      mobileHeader: this.querySelector('header-mobile'),
      drawerContainer: this.querySelector('.md-header__drawer'),
      menu: this.querySelector('.md-header__menu'),
      menuSwitchers: this.querySelectorAll('[data-level-aim]'),
    };
  }

  setEvents() {
    if (this.settings.mobileSticky) addEventListener('scroll', this.stickyHeader.bind(this));
    this.onResize();
    this.onToggleMenu();
    this.onSwitchMenu();
  }

  /*************************
    MAIN METHODS
  *************************/

  onResize() {
    window.addEventListener('resize', () => {
      this.getViewportHeight();
      this.getDistanceToTop();                    
    });
  }
  
  onToggleMenu() {
    this.selectors.menu.addEventListener('click', () => {
      let isMenuOpen = this.root.hasAttribute('drawer-mobile-open');
      if (isMenuOpen) {
        this.resetMenu(this.querySelector('[data-level-open]'));
        this.root.removeEventListener('click', this.onCloseMenuHandler);
      } else {
        this.getViewportHeight();
        this.getDistanceToTop();
        this.root.addEventListener('click', this.onCloseMenuHandler);
      }
      this.root.toggleAttribute('drawer-mobile-open');
    });
  }

  onSwitchMenu() {
    for (let switcher of this.selectors.menuSwitchers) {
      switcher.addEventListener(
        'click',
        e => {
          e.preventDefault();
          e.stopImmediatePropagation();
          // switch to active menu
          if (switcher.nodeName == 'BUTTON') {
            this.resetMenu(switcher.parentElement.parentElement.previousElementSibling, false);
          } else {
            switcher.setAttribute('data-level-open', '');
            setTimeout(() => {
              switcher.closest('.md-header__nav--content, nav').scroll(0, 0);
            }, 350);
          	
          }
          // translate drawer
          let levelAim = +switcher.dataset.levelAim;
          let translateX = levelAim == 3 ? '-200%' : levelAim == 2 ? '-100%' : '0%';
          this.selectors.drawerContainer.style.transform = `translateX(${translateX})`;
        },
        true
      );
    }
  }

  stickyHeader() {
    let scrolled = window.pageYOffset || this.root.scrollTop;
    let revealHeader = scrolled < this.scrollPos || scrolled < 300;
    // toggle sticky header
    this.header.classList.toggle('header-maxdesign--sticky', revealHeader);
    // reset scroll pos
    if (scrolled - this.scrollPos > 200 || this.scrollPos > scrolled) this.scrollPos = scrolled;
  }

  /*************************
  UTILITY METHODS
	*************************/

  getViewportHeight() {
    this.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  }

  getDistanceToTop() {
    this.style.setProperty('--header-top-position', `${this.getBoundingClientRect().top}px`);
  }

  /**
   * close menu on overlay click
   * @param {event} e
   */
  closeMenu(e) {
    if (e.target == e.currentTarget) {
      this.root.removeAttribute('drawer-mobile-open');
      this.resetMenu(this.querySelector('[data-level-open]'));
      this.root.removeEventListener('click', this.onCloseMenuHandler);
    }
  }

  /**
   * reset menu state
   * @param {object} switcher
   * @param {boolean} translate
   */
  resetMenu(switcher, translate = true) {
    setTimeout(() => {
      switcher && switcher.removeAttribute('data-level-open');
      if (translate) this.selectors.drawerContainer.style.transform = 'translateX(0%)';
    }, 350);
  }
}

customElements.get('header-maxdesign') || customElements.define('header-maxdesign', Header);
